module.exports = __webpack_public_path__ + "img/20251121_anniversary.9d9f4b88.jpg";